var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "carousel-chevron", attrs: { "data-carousel": "chevron" } },
    [
      _c(
        "a",
        {
          staticClass: "arrow-left effect-black",
          attrs: { "data-carousel": "chevron-left", href: "" }
        },
        [
          _c(
            "svg",
            {
              staticClass: "icon",
              staticStyle: { "pointer-events": "none", display: "block" },
              attrs: {
                viewBox: "0 0 24 24",
                preserveAspectRatio: "xMidYMid meet",
                focusable: "false",
                size: "icon-sm",
                "icon-size": "icon-lg"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "icon-narrow-angle-left-24",
                    stroke: "none",
                    "stroke-width": "1",
                    fill: "none",
                    "fill-rule": "evenodd",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        transform: "translate(-196, -226)",
                        stroke: "currentColor"
                      }
                    },
                    [
                      _c("polyline", {
                        attrs: {
                          transform:
                            "translate(209.000000, 237.500000) scale(-1.2, 1.2) rotate(90.000000) translate(-209.000000, -237.500000) ",
                          points: "200 242 209 233 218 242"
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "arrow-right effect-black",
          attrs: { "data-carousel": "chevron-right", href: "" }
        },
        [
          _c(
            "svg",
            {
              staticClass: "icon",
              staticStyle: { "pointer-events": "none", display: "block" },
              attrs: {
                viewBox: "0 0 24 24",
                preserveAspectRatio: "xMidYMid meet",
                focusable: "false",
                size: "icon-sm",
                "icon-size": "icon-lg"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "icon-narrow-angle-right-24",
                    stroke: "none",
                    "stroke-width": "1",
                    fill: "none",
                    "fill-rule": "evenodd",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        transform: "translate(-196, -226)",
                        stroke: "currentColor"
                      }
                    },
                    [
                      _c("polyline", {
                        attrs: {
                          transform:
                            "translate(209.000000, 237.500000) scale(-1.2, 1.2) rotate(-90.000000) translate(-209.000000, -237.500000) ",
                          points: "200 242 209 233 218 242"
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }